(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 320577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Home": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(370917);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(217674);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(152443);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(121214);
/* harmony import */ var components_AppHeader_AppHeader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(942714);
/* harmony import */ var components_SearchForm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(722662);
/* harmony import */ var components_SearchForm_search__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(780503);
/* harmony import */ var components_FeatureFlagsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96505);
/* harmony import */ var pages_layouts_BaseLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(624318);
/* harmony import */ var pages_layouts_BaseLayoutWithSideNav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(372855);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(135944);













var Home = function Home() {
  var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__.u)();

  var _useSearchParams = (0,components_SearchForm_search__WEBPACK_IMPORTED_MODULE_2__/* .useSearchParams */ .lr)(),
      _useSearchParams2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var searchHandler = function searchHandler(searchParams) {
    setSearchParams(searchParams);
  };

  var featureFlags = (0,components_FeatureFlagsProvider__WEBPACK_IMPORTED_MODULE_3__/* .useFeatureFlags */ .g)();
  var BaseLayout = featureFlags['show-side-navigation'] ? pages_layouts_BaseLayoutWithSideNav__WEBPACK_IMPORTED_MODULE_5__/* .BaseLayout */ .IE : pages_layouts_BaseLayout__WEBPACK_IMPORTED_MODULE_4__/* .BaseLayout */ .I;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(BaseLayout, {
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      disableGutters: true,
      maxWidth: "lg",
      component: "main",
      style: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center'
      },
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_AppHeader_AppHeader__WEBPACK_IMPORTED_MODULE_0__/* .AppHeader */ .t, {
        subtitle: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .Fragment */ .HY, {
          children: ["Find your price advantage on any lane ", (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("br", {}), "and win more customer loads."]
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .css */ .iv)({
          marginTop: theme.spacing(16)
        },  true ? "" : 0,  true ? "" : 0),
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(components_SearchForm__WEBPACK_IMPORTED_MODULE_1__/* .SearchForm */ .UI, {
          onSearch: searchHandler,
          initialForm: searchParams
        })
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 624318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ BaseLayout; }
/* harmony export */ });
/* harmony import */ var components_PageTitle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(327743);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(135944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var _ref2 =  true ? {
  name: "zjik7",
  styles: "display:flex"
} : 0;

var _ref3 =  true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0;

var BaseLayout = function BaseLayout(_ref) {
  var children = _ref.children,
      aside = _ref.aside,
      title = _ref.title;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(components_PageTitle__WEBPACK_IMPORTED_MODULE_0__/* .PageTitle */ .V, {
      optionalTitle: title
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
      css: _ref2,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("div", {
        css: _ref3,
        children: children
      }), aside]
    })]
  });
};

/***/ }),

/***/ 889208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(320577);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,429,855,80,774,888,179], function() { return __webpack_exec__(889208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);